<template>
<client-only>
  <div class="inner-wrap">
    <NoJobsBasket />
  </div>
  </client-only>
</template>

<script>
import NoJobsBasket from '@/components/Candidates/Pages/JobsBasket/NoJobsBasket'

export default {
  layout: 'personal',
  name: 'removePasswordPage',

  components: {
    NoJobsBasket
  },
    head() {
    return {
      meta: [
        {
          name: 'ROBOTS',
          content: 'NOINDEX, FOLLOW',
          hid: 'ROBOTS',
        },
      ],
    }
  },
}
</script>
